const userAgreementContent = `
<html>

<head>
<meta http-equiv=Content-Type content="text/html; charset=utf-8">
<meta name=Generator content="Microsoft Word 15 (filtered)">
<style>
.textContent {
    font-size: 10.5pt !important;
  }
</style>

</head>

<body lang=ZH-CN link=blue vlink="#954F72" style='word-wrap:break-word;
text-justify-trim:punctuation'>


<div class=textContent>


<p style='background:white'><span lang=EN-US style='font-size:10.5pt;
font-family:"Times New Roman",serif;background:white'>&nbsp;</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;layout-grid-mode:
char;background:white'><span style='font-size:10.5pt;font-family:宋体;color:black;
background:white'>更新日期：</span><span lang=EN-US style='font-size:10.5pt;
font-family:"Times New Roman",serif;color:black;background:white'>2024</span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>年</span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'>8</span><span style='font-size:10.5pt;font-family:
宋体;color:black;background:white'>月</span><span lang=EN-US style='font-size:
10.5pt;font-family:"Times New Roman",serif;color:black;background:white'>19</span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>日</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>&nbsp;</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span style='font-size:10.5pt;font-family:宋体;color:black;
background:white'>《蛮啾用户许可及服务协议》由您与蛮啾共同缔结，《蛮啾用户许可及服务协议》及</span><span
style='font-size:10.5pt;font-family:宋体'>蛮啾</span><span style='font-size:10.5pt;
font-family:宋体;color:black;background:white'>向您提供相关产品和服务时与您达成的关于使用蛮啾产品和服务的其他各项规则、条款和条件，以下称“<b>本协议</b>”。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span style='font-size:10.5pt;font-family:宋体'>本协议仅适用于蛮啾在中国大陆地区发行的游戏产品及其提供的服务</span></b><span
style='font-size:10.5pt;font-family:宋体'>。如果用户使用“蛮啾”或“</span><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif'>Manjuu</span><span
style='font-size:10.5pt;font-family:宋体'>”品牌旗下在其他地区发行的游戏产品或服务，那么这些服务将由蛮啾的合作伙伴或其他第三方提供。请访问相应产品及服务的下载页面（例如游戏官方网站、</span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif'>App
Store</span><span style='font-size:10.5pt;font-family:宋体'>或</span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif'>Google
Play</span><span style='font-size:10.5pt;font-family:宋体'>商店等）以查看适用的服务条款。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span style='font-size:10.5pt;font-family:宋体;color:black;
background:white'>本协议具有合同效力，<b>在您使用蛮啾提供的产品和服务前，请您务必审慎阅读、充分理解各条款内容以及蛮啾公布的各项服务规则（包括但不限于用户许可及服务协议、</b></span><b><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'><a
href="/zh/protocol/privacy" target="_blank"><span lang=EN-US
style='font-family:宋体'><span lang=EN-US>隐私政策</span></span></a></span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>、账号注销说明、网络游戏防沉迷规则、实名认证规则，以及蛮啾在单项产品和服务中所发布的公告、规则等），<u>特别是免除蛮啾责任的条款（此类条款通常包含“不担保”“无义务”“不承担责任”等词汇）、限制用户权利的条款（此类条款通常包含“不得”“无权”）</u></span></b><u><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>，<b>个人信息保护、账号和权益、未成年人保护、法律管辖等可能和您有重大利害关系的条款，上述条款可能以加粗或下划线等显著形式提示您注意</b></span></u><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>。</span></b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>请您在确认同意本协议之前或在使用蛮啾服务之前再次阅读前述条款。如果您不同意本协议的任何内容，或者无法准确理解相关条款的含义，请不要进行后续操作。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span style='font-size:10.5pt;font-family:宋体;
color:black;background:white'>除非您已阅读且接受本协议的所有条款，否则您将无法使用蛮啾提供的产品和服务</span></b><b><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>。</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>您通过网站页面或在产品内点击同意本协议和</span></b><b><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'>/</span></b><b><span style='font-size:10.5pt;
font-family:宋体;color:black;background:white'>或实际使用本产品和服务的行为</span></b><b><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>均</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>视为您已阅读、理解并同意接受本协议。</span></b></p>

<p style='margin-bottom:17.6pt;text-align:justify;text-justify:inter-ideograph;
text-indent:21.0pt;layout-grid-mode:char'><b><span style='font-size:10.5pt;
font-family:宋体;color:black;background:white'>若用户不满</span></b><b><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'>18</span></b><b><span style='font-size:10.5pt;
font-family:宋体;color:black;background:white'>周岁或非为完全民事行为能力人的，在使用蛮啾提供的产品和服务前，请在父母或者其他法定监护人的陪同下阅读本协议，特别注意未成年人相关条款，并在获得法定监护人同意后方可使用蛮啾产品及服务。我们鼓励未成年人的父母或其他法定监护人指导未成年人使用本产品和服务。若您登录、注册、使用或接受蛮啾提供的产品或服务，即表示：您已年满</span></b><b><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'>18</span></b><b><span style='font-size:10.5pt;
font-family:宋体;color:black;background:white'>周岁；或：您未满</span></b><b><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'>18</span></b><b><span style='font-size:10.5pt;
font-family:宋体;color:black;background:white'>周岁，但已获得法定监护人的同意。</span></b></p>

<p style='margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
text-indent:0cm;layout-grid-mode:char'><b><span lang=EN-US style='font-size:
11.0pt;font-family:"Times New Roman",serif'>1. </span></b><b><span
style='font-size:11.0pt;font-family:宋体;color:black;background:white'>概述</span></b><b><span
lang=EN-US style='font-size:11.0pt;font-family:"Times New Roman",serif;
color:black;background:white'>&nbsp;</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>1.1</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>定义：</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>1.1.1 </span><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>蛮啾</span></b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>：指向您提供游戏服务的上海蛮啾网络科技有限公司及其关联公司。关联公司是指在现在、将来控制上海蛮啾网络科技有限公司、受上海蛮啾网络科技有限公司控制或与上海蛮啾网络科技有限公司处于共同控制下的公司、机构。控制指通过所有权、有投票权的股份、合同、实际运营关联或其他被依法认定的方式直接或间接地拥有影响被控制对象管理</span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'>/</span><span style='font-size:10.5pt;font-family:
宋体;color:black;background:white'>经营的能力。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>1.1.2 </span><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>您</span></b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>：又称“<b>玩家</b>”或“<b>用户</b>”，指被授权使用游戏服务的自然人。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>1.1.3 </span><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>蛮啾游戏</span></b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>：又称“<b>产品</b>”，为蛮啾负责运营的各终端游戏（如有）及其他软件、网站等各类产品的统称</span><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>；</span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>蛮啾</span><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>游戏</span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>可能以软件形式提供，这种情况下蛮啾</span><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>游戏</span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>还包括该相关软件及相关文档，但本协议另有明确释明的除外。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>1.1.4 </span><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>游戏服务</span></b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>：又称“<b>服务</b>”，指蛮啾向您提供的产品及其相关的各项运营服务，包括但不限于用户账号注册及维护、游戏充值、游戏推广、游戏活动策划及举办等。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>1.1.5 </span><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>服务规则</span></b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>：指蛮啾不时发布并修订的游戏许可及服务协议、</span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'><a
href="/zh/protocol/privacy" target="_blank"><span lang=EN-US
style='font-family:宋体'><span lang=EN-US>隐私政策</span></span></a></span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>、账号注销说明、网络游戏防沉迷规则、实名认证规则，活动规则、关于游戏的用户守则、玩家条例，以及蛮啾在单项产品和服务中所发布的公告、通知、规则等内容。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>1.1.6 </span><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>用户账号</span></b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>：又称“<b>账号</b>”，包括但不限于“蛮啾通行证”，指用户为使用游戏服务，依照本协议及相关法规政策规定成功注册的用户账号，并以该账号体验蛮啾游戏及相关服务。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>1.1.7 </span><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>游戏数据</span></b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>：指您在使用游戏或接受游戏服务过程中产生的被服务器或其他平台记录的各种数据内容，包括游戏日志、安全日志等数据。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>1.1.8 </span><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>外挂程序</span></b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>：是指独立于产品及服务之外的，能够在产品运行的同时影响产品操作的所有程序，包括但不限于模拟操作、改变操作环境、修改数据等一切类型。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>1.1.9 </span><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>终止服务</span></b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>：指蛮啾向用户停止服务，而非对个别用户进行的封号、禁止登录、删除游戏道具或游戏币、强制离线等措施。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>1.1.10 </span><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>测试服务器</span></b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>：又称“<b>测试服</b>”，指蛮啾在游戏产品的测试阶段（包括但不限于封测、内测和公测）中向您提供产品和服务的服务器。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>1.1.11 </span><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>体验服务器</span></b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>：又称“<b>体验服</b>”，指蛮啾在某些游戏产品中推出的测试最新版本游戏系统及游戏内容的稳定性的服务器，您可以在体验服务器中体验最新的产品和服务内容。</span></p>

<p style='margin-bottom:17.6pt;text-align:justify;text-justify:inter-ideograph;
text-indent:21.0pt;layout-grid-mode:char'><span lang=EN-US style='font-size:
10.5pt;font-family:"Times New Roman",serif;color:black;background:white'>1.2 </span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>蛮啾有权更改本协议及蛮啾各产品和服务的其他相关服务规则。</span><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>我们会在官网</span><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>相关页面或各单项产品和服务的页面</span></b><b><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>发布修改后的</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>协议及各服务规则。若您不同意</span></b><b><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>我们对前述内容</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>作出的修改，您可以主动停止使用蛮啾提供的产品和服务。<u>如果在蛮啾修改协议或服务规则后，您仍继续使用蛮啾提供的产品和服务，即表示您同意蛮啾对本协议及相关服务规则所做的修改。</u></span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;layout-grid-mode:
char'><b><span lang=EN-US style='font-size:11.0pt;font-family:"Times New Roman",serif;
color:black;background:white'>2. </span></b><b><span style='font-size:11.0pt;
font-family:宋体;color:black;background:white'>知识产权和所有权</span></b><b><span
lang=EN-US style='font-size:11.0pt;font-family:"Times New Roman",serif;
color:black;background:white'>&nbsp;</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>2.1 </span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>蛮啾系蛮啾游戏的合法知识产权权利人及运营方，及</span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'>/</span><span style='font-size:10.5pt;font-family:
宋体;color:black;background:white'>或已从合法权利人处取得全部合法授权及许可，从而有权为您提供游戏服务。本协议项下产品（包括但不限于蛮啾游戏整体及蛮啾游戏涉及的所有内容、组成部分或构成要素）的一切著作权、商标权、专利权、商业秘密等知识产权及运营蛮啾游戏的一切合法权益，以及与蛮啾游戏相关的所有信息内容（以下简称“<b>蛮啾游戏相关信息内容</b>”），包括但不限于游戏画面、游戏玩法、游戏素材、游戏音乐、文字表述及其组合、图标、图饰、图表、色彩组合、界面设计、版面框架、有关数据、印刷材料或电子文档等均受中华人民共和国法律法规和中华人民共和国加入并签署的国际条约保护，蛮啾享有上述知识产权和</span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'>/</span><span style='font-size:10.5pt;font-family:
宋体;color:black;background:white'>或合法权益，但相关权利人依照中华人民共和国法律规定应享有的权利除外。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.4pt;
layout-grid-mode:char'><b><u><span lang=EN-US style='font-size:10.5pt;
font-family:"Times New Roman",serif;color:black;background:white'>2.2 </span></u></b><b><u><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>除非事先获得蛮啾的合法授权</span></u></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>，您不得对任何蛮啾游戏相关信息内容，包括但不限于美术、音乐、软件代码、技术信息、资料等进行修改、抄袭、复制、传播、传送、展示、发行、授权、制作衍生作品或销售，法律法规允许合理使用的除外。</span></b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>如您未遵守本条款的上述规定，在法律所允许的最大限度内，且在不损害其他相关方权利的情况下，蛮啾可立即终止向您提供产品和服务，</span><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>且</span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>您必须销毁任何已经获得的上述服务或产品内容。<b>本协议未明确授予用户的权利均由蛮啾保留。</b></span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>2.3 </span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>蛮啾对您在使用蛮啾产品过程中或接受蛮啾的服务过程中所产生的任何数据信息（包括但不限于账号资料、游戏数据及系统衍生数据等）拥有所有权。<b>您通过</b></span><b><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>您的</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>合法账号及密码或验证码正常登录蛮啾特定产品后，该产品的界面向您显示的数据和信息为您就</span></b><b><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>账号使用权能够</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>获取的全部数据和信息。您仅有权依据本协议及有关服务规则在该款产品中使用该等数据和信息。除法律另有规定外，蛮啾无义务向您提供、展示</span></b><b><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>除</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>您自行登录使用产品便可获取的数据和信息以外的数据和信息。</span></b></p>

<p style='margin-bottom:17.6pt;text-align:justify;text-justify:inter-ideograph;
text-indent:21.0pt;layout-grid-mode:char'><b><span lang=EN-US style='font-size:
10.5pt;font-family:"Times New Roman",serif;color:black;background:white'>2.4 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>蛮啾产品和服务中的各种用户账号下的权益，包括但不限于游戏币</span></b><b><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'>/</span></b><b><span style='font-size:10.5pt;
font-family:宋体;color:black;background:white'>券、道具（含装备）等，是蛮啾所提供的服务的一部分，<u>其所有权归属蛮啾</u>。您只能在合乎法律规定和服务规则的情况下获得使用的授权，且可通过游戏行为和充值行为获准使用用户账号权益。本协议所称您对“游戏道具或权益的交换</span></b><b><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'>/</span></b><b><span style='font-size:10.5pt;
font-family:宋体;color:black;background:white'>转让”均指<u>游戏道具及相关权益使用权</u>的交换</span></b><b><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'>/</span></b><b><span style='font-size:10.5pt;
font-family:宋体;color:black;background:white'>转让，<u>您无权交换</u></span></b><b><u><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'>/</span></u></b><b><u><span style='font-size:
10.5pt;font-family:宋体;color:black;background:white'>转让游戏道具及相关权益的所有权。</span></u></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;layout-grid-mode:
char'><b><span lang=EN-US style='font-size:11.0pt;font-family:"Times New Roman",serif;
color:black;background:white'>3. </span></b><b><span style='font-size:10.5pt;
font-family:宋体;color:black;background:white'>用户账号</span></b><b><span
style='font-size:11.0pt;font-family:宋体;color:black;background:white'>及收费</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>3.1 </span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>您承诺以其真实身份注册用户账号，并保证所提供的个人身份资料信息真实、完整、有效，依据法律规定和本协议约定对所提供的信息承担相应的法律责任。蛮啾有权自行或通过第三方服务审查您注册所提供的身份信息是否真实、有效，并应积极地采取技术与管理等合理措施保障您账号的安全、有效。您有义务妥善保管并正确、安全地使用账号及密码。</span><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>若</span><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>您未尽上述义务导致账号密码遗失、账号被盗等情形而给自身造成损害的，由您自己承担由此产生的直接和间接损失。包括但不限于下列情形：</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>3.1.1 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>因技术障碍或失窃而导致账号丢失，而您未充分举证证明账号密码遗失、被盗由蛮啾故意或重大过失导致，则蛮啾不承担找回失窃账号给您造成的损失。</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>3.1.2 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>蛮啾找回了失窃账号但不保证账号内的全部物品的安全与完整。</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>3.1.3 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>失窃账号内的物品经过一次或多次流转被其他用户合法获得后，蛮啾不承担无法找回而导致的损失等。</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>3.2 </span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>您申请注册成功后，蛮啾有权根据各产品商业运营情况给您</span><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>分配</span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>用户账号。<b>账号一旦设定，未经蛮啾同意不可变更。</b>蛮啾有权就您名下的不同账号进行单独或整体的管理。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>3.3 </span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>您在注册时应提供完整、详尽、真实的个人资料，若所提供的资料日后有变更，您应及时登录账号或通过我们公布的联系方式联系我们进行更新及修改。<b>您以真实身份注册后，需要修改所提供的个人身份资料信息或账号密码的，蛮啾应当按照本协议及蛮啾相关服务规则及时、有效地为您提供该项服务，但实名信息一经认证不得修改。若您向蛮啾提供的个人资料与事实不符，蛮啾有权停止向</b></span><b><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>您</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>继续提供产品和服务。当您向蛮啾主张某账号</span></b><b><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>的</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>使用权时，<u>若该账号在蛮啾的身份信息记录与您的身份信息有任何不符，蛮啾有权</u></span></b><b><u><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>拒绝您的请求</span></u></b><b><u><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>。</span></u></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>3.4 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>用户账号仅为蛮啾依照本协议授权您进行登录、使用蛮啾产品及服务的标识和凭证，用户账号的所有权归蛮啾所有，您仅依据服务规则享有账号的使用权。在无充足相反证据证明的情况下，您账号</span></b><b><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>的</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>使用权属于注册人。未经蛮啾允许，您不得对账号使用权进行买卖、赠与、交换、继承或任何其他形式的交易。您不得将账号、密码、账号</span></b><b><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>注册人</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>的身份信息等泄漏或提供给他人知悉，也不得将账号出借或转让给他人使用。</span></b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>如因您自身过错或您的计算机感染病毒或木马，而导致账号或密码泄漏的，您应自行承担由此造成的损失。蛮啾（包括但不限于蛮啾的网站和论坛管理人员、客服人员等）不会以任何方式询问您的密码，您不应对任何人泄漏您的密码或</span><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>他人</span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>共享同一个账号，不要安装非法或来路不明的程序。如果您遗失了密码，蛮啾针对处理此问题之服务保留索取额外费用的权利。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>3.5 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>若您发现账号或密码被他人非法使用或有异常使用的情形，应立即根据蛮啾公布的处理方式通知蛮啾，并有权通知蛮啾暂停该账号的登录和使用，但您在申请时应履行必要的手续，诸如提供与其注册身份信息相一致的个人有效身份信息。</span></b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>蛮啾核实您所提供的个人有效身份信息与所注册的身份信息相一致的，将按照本协议及蛮啾的相关服务规则等及时采取措施暂停您账号的登录和使用，但蛮啾对</span><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>账号暂停使用前</span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>您账号已执行的指令不承担责任。您没有提供个人有效身份证件或者您提供的个人有效身份证件与所注册的身份信息不一致的，蛮啾有权拒绝您的上述请求。</span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'>&nbsp;</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>3.6 </span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>蛮啾可能会向您提供一定的免费或收费的保护账号密码的辅助工具，但您知悉并同意：这些工具只能在一定程度上提高账号和密码的安全，<b><u>蛮啾并不担保您在使用此类辅助工具后就能保障账号密码的绝对安全。</u></b></span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>3.7 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>蛮啾在服务器数据或账号数据（例如用户账号或游戏角色、游戏礼包、代金券、优惠券、游戏道具、游戏装备、游戏币等）出现异常时，有权暂时冻结您的账号；蛮啾有权采取相应的措施对数据进行处理，处理措施包括但不限于恢复用户账号数据至异常发生前的原始状态（包括但不限于向第三方追回被转移数据，扣除游戏礼包内容、账户内代金券、优惠券、游戏道具、游戏装备、游戏币）、删除用户账号或其他蛮啾认为合理的措施，或将该服务器的数据还原到一定时点，对因此可能导致的您账号内游戏道具等发生减损的情形，蛮啾无需向您承担任何责任。前述异常包括但不限于：</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>3.7.1 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>因程序</span></b><b><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'>BUG</span></b><b><span style='font-size:10.5pt;
font-family:宋体;color:black;background:white'>、版本更新缺陷、第三方病毒攻击或其他任何因素发生异常；</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>3.7.2 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>利用非法手段或通过其他未经蛮啾授权的第三方充值导致账号异常，因账号使用人与实名认证信息不符等导致账号异常或权属存在争议；</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>3.7.3 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>账号存在恶意退款情形，前述恶意退款包括但不限于用户通过充值获得游戏礼包、代金券、游戏内道具、资源、装备等增值服务后，自行进行退款操作而未通过蛮啾公布的客服联系方式通知蛮啾扣除相应账号资源；</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>3.7.4 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>账号存在违反本协议的其他情形。</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>3.8 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>您充分理解并同意：</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>3.8.1 </span></b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>蛮啾向您提供虚拟增值服务本身属于商业行为，您有权自主决定是否根据蛮啾或蛮啾授权的第三方提供的收费项目（包括但不限于购买游戏礼包、代金券、优惠券、获得游戏内的游戏虚拟道具的使用权、接受其他增值服务等各类收费项目）及收费标准支付相应的费用，以获得相应的虚拟增值服务。<b>如您不支付相应费用的，您将无法获得相应的服务。</b></span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>3.8.2 </span></b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>收费项目或收费标准的改变、调整是一种正常的商业行为，<b>您不得因为收费项目或收费标准的改变、调整而要求蛮啾或蛮啾关联公司进行赔偿或补偿。</b></span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>3.8.3 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>蛮啾产品及服务中提供的各类虚拟物品及增值服务，若对使用期限或次数有特殊标注或说明的，其使用期限和次数以说明为准，若超出标注的使用期限和次数的，蛮啾有权采取措施限制或停止您对前述虚拟物品及增值服务的使用，或不另行通知您而随时收回相关物品及服务。</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>3.8.4 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>您使用法定货币通过蛮啾产品或服务进行礼包购买、兑换游戏虚拟道具或其他增值服务的，您所购买或兑换的游戏虚拟道具、礼包或其他增值服务将不能退还或兑换成法定货币，但法律另有强制性规定的除外。</span></b></p>

<p style='margin-bottom:17.6pt;text-align:justify;text-justify:inter-ideograph;
text-indent:21.0pt;layout-grid-mode:char'><b><span lang=EN-US style='font-size:
10.5pt;font-family:"Times New Roman",serif;background:white'>&nbsp;</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;layout-grid-mode:
char'><b><span lang=EN-US style='font-size:11.0pt;font-family:"Times New Roman",serif;
color:black;background:white'>4. </span></b><b><span style='font-size:11.0pt;
font-family:宋体;color:black;background:white'>软件许可</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>4.1 </span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>您使用产品或接受蛮啾提供的游戏服务需要下载并安装产品，您可以直接从蛮啾运营的官方网站上获取产品，也可以从得到蛮啾授权的第三方获取。<b><u>如果您从未经蛮啾授权的第三方获取产品或与</u>产品<u>名称相同的游戏，将视为您未获得蛮啾授权，蛮啾无法保证该游戏能够正常使用，因此给您造成的全部损失由您自行承担责任。</u></b></span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>4.2 </span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>蛮啾可能为不同的终端设备或操作系统开发了不同的软件版本，包括但不限于</span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'>Windows</span><span style='font-size:10.5pt;
font-family:宋体;color:black;background:white'>、</span><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black;
background:white'>iOS</span><span style='font-size:10.5pt;font-family:宋体;
color:black;background:white'>、</span><span lang=EN-US style='font-size:10.5pt;
font-family:"Times New Roman",serif;color:black;background:white'>Android</span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>等多个应用版本，您应当根据实际情况选择下载合适的版本进行安装，下载安装程序后，您需要按照该程序提示的步骤正确安装。<b>用户充分理解并同意，不同操作系统之间可能存在不互通的客观情况，由此可能导致用户在某一操作系统中的充值和游戏数据不能顺利转移到另一操作系统中。由于用户在不同操作系统进行切换造成的充值损失和游戏数据丢失风险应由用户自行承担，蛮啾不承担任何责任。</b></span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>4.3 </span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>在您同意接受本协议全部条款的前提下，蛮啾以软件形式提供游戏服务并同意授予您个人的、非商业使用性质的、非营利性质的、可撤销的、可变更的、非专有的、不可转让、暂时性的和不可转授权的使用蛮啾游戏及游戏服务的权利，您仅可在蛮啾前述授权范围内在终端设备上下载、安装、登录、使用该游戏以及游戏服务，并以蛮啾指定的方式运行蛮啾游戏并享受游戏服务。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>4.4 </span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>蛮啾基于本协议授予您的许可是针对个人使用的许可。<b>如您有需要在个人使用的范围以外使用蛮啾游戏软件及游戏服务或者将</b></span><b><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>其</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>用于任何商业用途，则您应与蛮啾联系并获得另行书面授权。任何未经蛮啾许可的安装、使用、访问、显示、运行、商业使用等行为均属侵权。</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>4.5 </span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>如果您不再需要使用游戏或者需要安装更新版本的游戏软件，可以自行卸载。如果您愿意帮助蛮啾改进游戏及游戏服务，请告知卸载的原因。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>4.6 </span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>为了保证蛮啾为您提供的游戏以及游戏服务的安全性和功能的一致性，蛮啾有权不经向您特别通知而对游戏软件或游戏服务进行更新，或者对游戏软件或游戏服务的部分功能效果进行改变或限制。</span></p>

<p style='margin-bottom:17.6pt;text-align:justify;text-justify:inter-ideograph;
text-indent:21.0pt;layout-grid-mode:char'><span lang=EN-US style='font-size:
10.5pt;font-family:"Times New Roman",serif;color:black;background:white'>4.7 </span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>软件新版本发布后，旧版本的软件可能无法使用。蛮啾不保证旧版软件或对应的游戏服务继续可用，若您需要蛮啾继续提供游戏服务的，请您随时核对并下载最新版本。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;layout-grid-mode:
char'><b><span lang=EN-US style='font-size:11.0pt;font-family:"Times New Roman",serif;
color:black;background:white'>5. </span></b><b><span style='font-size:11.0pt;
font-family:宋体;color:black;background:white'>用户行为规范</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>5.1 </span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>您可以根据本协议以及蛮啾公布的服务规则等来接受蛮啾提供的产品和服务。您有权在接受蛮啾提供的产品和服务的期间监督蛮啾及蛮啾的工作人员是否按照蛮啾所公布的标准向您提供产品和服务，也可以随时向蛮啾提出与蛮啾的产品和服务有关意见和建议。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>5.2 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>您在拥有合法使用权的账号下，可以在蛮啾的产品内发布或上传使用服务所必需的内容，但不得利用蛮啾的服务或产品发送或传播不当信息和违反国家法律法规的内容，包括但不限于以下内容：</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>5.2.1 </span></b><b><u><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>反对宪法所确定的基本原则的</span></u></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>；</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>5.2.2 </span></b><b><u><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的</span></u></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>；</span></b></p>

<p style='margin-left:21.0pt;text-align:justify;text-justify:inter-ideograph;
layout-grid-mode:char'><b><u><span lang=EN-US style='font-size:10.5pt;
font-family:"Times New Roman",serif;color:black;background:white'>5.2.3 </span></u></b><b><u><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>损害国家荣誉和利益的</span></u></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>；</span></b></p>

<p style='margin-left:21.0pt;text-align:justify;text-justify:inter-ideograph;
layout-grid-mode:char'><b><u><span lang=EN-US style='font-size:10.5pt;
font-family:"Times New Roman",serif;color:black;background:white'>5.2.4 </span></u></b><b><u><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>煽动民族仇恨、民族歧视，破坏民族团结的</span></u></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>；</span></b></p>

<p style='margin-left:21.0pt;text-align:justify;text-justify:inter-ideograph;
layout-grid-mode:char'><b><u><span lang=EN-US style='font-size:10.5pt;
font-family:"Times New Roman",serif;color:black;background:white'>5.2.5 </span></u></b><b><u><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>破坏国家宗教政策，宣扬邪教和封建迷信的</span></u></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>；</span></b></p>

<p style='margin-left:21.0pt;text-align:justify;text-justify:inter-ideograph;
layout-grid-mode:char'><b><u><span lang=EN-US style='font-size:10.5pt;
font-family:"Times New Roman",serif;color:black;background:white'>5.2.6 </span></u></b><b><u><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>散布谣言，扰乱社会秩序，破坏社会稳定的</span></u></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>；</span></b></p>

<p style='margin-left:21.0pt;text-align:justify;text-justify:inter-ideograph;
layout-grid-mode:char'><b><u><span lang=EN-US style='font-size:10.5pt;
font-family:"Times New Roman",serif;color:black;background:white'>5.2.7 </span></u></b><b><u><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的</span></u></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>；</span></b></p>

<p style='margin-left:21.0pt;text-align:justify;text-justify:inter-ideograph;
layout-grid-mode:char'><b><u><span lang=EN-US style='font-size:10.5pt;
font-family:"Times New Roman",serif;color:black;background:white'>5.2.8 </span></u></b><b><u><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>侮辱或者诽谤他人</span></u></b><b><u><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'>/</span></u></b><b><u><span style='font-size:
10.5pt;font-family:宋体;color:black;background:white'>侵害他人合法权益的</span></u></b><b><u><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'>/</span></u></b><b><u><span style='font-size:
10.5pt;font-family:宋体;color:black;background:white'>骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的、欺诈性的或其他任何非法的；</span></u></b></p>

<p style='margin-left:21.0pt;text-align:justify;text-justify:inter-ideograph;
layout-grid-mode:char'><b><u><span lang=EN-US style='font-size:10.5pt;
font-family:"Times New Roman",serif;color:black;background:white'>5.2.9 </span></u></b><b><u><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>违反公序良俗的；</span></u></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><u><span lang=EN-US style='font-size:10.5pt;
font-family:"Times New Roman",serif;color:black;background:white'>5.2.10 </span></u></b><b><u><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>任何</span></u></b><b><u><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>侵犯</span></u></b><b><u><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>第三方</span></u></b><b><u><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>知识产权或其他权益的；</span></u></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><u><span lang=EN-US style='font-size:10.5pt;
font-family:"Times New Roman",serif;color:black;background:white'>5.2.11 </span></u></b><b><u><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>任何毁谤他人，性骚扰，种族歧视，或对未成年人有不良影响的；</span></u></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>5.2.12 </span></b><b><u><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>包含病毒、木马程序等可能对蛮啾或任何人的计算机系统造成伤害或影响其稳定性的；</span></u></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><u><span lang=EN-US style='font-size:10.5pt;
font-family:"Times New Roman",serif;color:black;background:white'>5.2.13</span></u></b><b><u><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>任何经蛮啾合理判断为不妥当或者蛮啾未认可的软件、文件及其他内容的</span></u></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>；</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>5.2.14 </span></b><b><u><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>含有法律、行政法规禁止的其他内容的。</span></u></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>5.3 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>如果您不同意本协议或相关服务规则，不接受蛮啾对本协议或服务规则不时作出的修改，您可以随时停止使用蛮啾的产品和服务。如果您选择停止使用蛮啾的产品和服务，则视为您放弃其用户账号及账号内相应的游戏道具使用权等</span></b><b><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>一切权益</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>，蛮啾对您不承担任何义务和责任。</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>5.4 </span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>您需自行配备注册和使用蛮啾产品和服务所需的各项计算机及网络设备以及网络资源，并自行负担上网所需的各项费用。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>5.5 </span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>您有义务妥善保管使用用户账号和蛮啾各产品及服务有关的身份信息和证件。<b><u>您对登录后所持账号产生的行为依法享有权利和承担责任，使用该账号的人即被视为您本人，其做出的任何行为也将视为您的行为，您应当为此账号使用者的一切行为负责。</u></b></span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>5.6 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>在使用蛮啾产品和接受蛮啾服务的过程中，您：</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>5.6.1 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>不得为任何非法目的而使用服务系统；</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>5.6.2 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>不得对蛮啾产品及服务进行修改，</span></b><b><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>反向</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>工程，</span></b><b><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>反向编译</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>，反向</span></b><b><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>汇编</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>、复制或</span></b><b><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>传播</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>，也不得修改蛮啾产品及服务所使用的任何专有通讯协议、对动态随机存取内存中资料进行修改或锁定；</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>5.6.3 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>不得采取任何可能影响蛮啾服务的非正常使用行为（包括但不限于损害、攻击服务器或使服务器过度负荷等）；</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>5.6.4 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>不得使用任何外挂程序或游戏修改程序；</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>5.6.5 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>不得通过未经蛮啾认可的第三方软件或在第三方软件的辅助下使用蛮啾的产品或接受蛮啾的服务；</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>5.6.6 </span></b><b><u><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>不得采取任何破坏服务规则和违反游戏公平性的行为</span></u></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><u><span lang=EN-US style='font-size:10.5pt;
font-family:"Times New Roman",serif;color:black;background:white'>5.6.7 </span></u></b><b><u><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>不得采取利用</span></u></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>游戏道具交易或其他方式通过蛮啾产品或服务进行盈利的行为，前述行为包括但不限于：</span></b></p>

<p style='margin-left:21.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:0cm;layout-grid-mode:char'><b><span lang=EN-US style='font-size:
10.5pt;font-family:"Times New Roman",serif'>(1) </span></b><b><u><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>注册多个用户账号和</span></u></b><b><u><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'>/</span></u></b><b><u><span style='font-size:
10.5pt;font-family:宋体;color:black;background:white'>或游戏角色</span></u></b><b><u><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'>ID</span></u></b><b><u><span style='font-size:
10.5pt;font-family:宋体;color:black;background:white'>，以营利为目的进行游戏行为，使用蛮啾产品和服务</span></u></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>；</span></b></p>

<p style='margin-left:21.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:0cm;layout-grid-mode:char'><b><span lang=EN-US style='font-size:
10.5pt;font-family:"Times New Roman",serif'>(2) </span></b><b><u><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>通过蛮啾产品内的单一或系列产出玩法，将获得的游戏道具等虚拟物品或实物奖励等出售获利</span></u></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>；</span></b></p>

<p style='margin-left:21.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:0cm;layout-grid-mode:char'><b><span lang=EN-US style='font-size:
10.5pt;font-family:"Times New Roman",serif'>(3) </span></b><b><u><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>利用不同服务器的游戏道具价值差异，在不同服务器买卖游戏道具获利</span></u></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>；</span></b></p>

<p style='margin-left:21.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:0cm;layout-grid-mode:char'><b><span lang=EN-US style='font-size:
10.5pt;font-family:"Times New Roman",serif'>(4) </span></b><b><u><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>充当用户账号、游戏道具或其他产品内的虚拟物品或者增值服务的交易中介收取费用获利</span></u></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>；</span></b></p>

<p style='margin-left:21.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:0cm;layout-grid-mode:char'><b><span lang=EN-US style='font-size:
10.5pt;font-family:"Times New Roman",serif'>(5) </span></b><b><u><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>在非蛮啾提供或认可的交易平台上交易</span></u></b><b><u><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>用户</span></u></b><b><u><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>账号或游戏道具获利</span></u></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>；</span></b></p>

<p style='margin-left:21.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:0cm;layout-grid-mode:char'><b><span lang=EN-US style='font-size:
10.5pt;font-family:"Times New Roman",serif'>(6) </span></b><b><u><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>将蛮啾游戏内获得的游戏道具用于出售获利而不注重本身角色实力的提升</span></u></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>；</span></b></p>

<p style='margin-left:21.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:0cm;layout-grid-mode:char'><b><span lang=EN-US style='font-size:
10.5pt;font-family:"Times New Roman",serif'>(7) </span></b><b><u><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>利用蛮啾游戏行为和游戏内容组织或参与赌博、实施或参与实施盗窃他人财产或游戏道具等涉嫌违法犯罪行为的</span></u></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>；</span></b></p>

<p style='margin-left:21.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:0cm;layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;
font-family:"Times New Roman",serif'>(8) </span><b><u><span style='font-size:
10.5pt;font-family:宋体;color:black;background:white'>其他任何不以正常的游戏娱乐需要为目的的游戏内牟利行为</span></u></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>。</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>5.6.8</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>不得使用异常的方法登录游戏（包括但不限于使用非蛮啾开发、授权或认可的第三方软件、系统登录游戏）、使用作废信用卡、盗窃他人信用卡等手段（俗称“黑卡”）进行充值、使用网络加速器等外挂软件或机器人程序等恶意破坏服务设施、扰乱正常服务秩序；</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>5.6.9</span></b><b><u><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>不得制作、传播或使用外挂、封包、加速软件及其他各种作弊程序，或组织、教唆他人使用此类软件程序，或销售此类软件程序而为个人或组织谋取经济利益；</span></u></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>5.6.10</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>不得使用任何方式或方法，试图攻击提供游戏服务的相关服务器、路由器、交换机以及其他设备，以达到非法获得或修改未经授权的数据资料、影响正常游戏服务或其他危害性目的；</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>5.6.11</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>不得利用线上游戏系统可能存在的技术缺陷或漏洞而以各种形式为自己及他人牟利（包括但不限于复制游戏中的游戏道具等）或者从事其他不正当行为；</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>5.6.12</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>未经蛮啾书面许可，不得使用蛮啾任何知识产权来创造或提供相同或类似的网络服务，如仿真服务器、私人服务器等；</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>5.6.13</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>不得利用蛮啾产品和网络服务系统进行任何可能对互联网的正常运转造成不利影响或可能干扰他人以正常方式使用蛮啾所提供的产品和网络服务的行为；</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>5.6.14</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>不得利用蛮啾服务系统进行其他不利于蛮啾的行为；</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>5.6.15</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>不得利用蛮啾的服务或产品进行违规喊话、违规操作，包括但不限于发送或传播非经蛮啾认可的第三方网址、游戏交易平台、诱导其他用户搜索第三方游戏平台、第三方交易信息、代练、代充值等信息；</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>5.6.16</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>就蛮啾及合作商业伙伴的服务、产品、业务咨询应采取蛮啾指定的客户服务渠道和其他专门沟通渠道，不得在公众场合发布有关蛮啾及其相关服务的负面宣传；</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>5.6.17</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>不得以违反服务规则等非正常方式获得游戏中的权益（包括但不限于游戏币、游戏道具等）；</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>5.7</span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>如您发现任何非法使用您账号或账号出现安全漏洞的情况，应立即通知蛮啾。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>5.8</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>您只能通过蛮啾游戏内置的交换途径（如有）和经蛮啾官方认可的第三方交易平台（如有）进行用户账号下的权益（包括但不限于游戏币、游戏装备等）的交换或转让。在非蛮啾提供或认可的交易平台上进行游戏道具的交易，将不受蛮啾认可或保护，由此产生的纠纷应由您自行解决。同时未经蛮啾允许不得将蛮啾游戏产品中的用户账号、角色人物、游戏道具等与现实货币或者实物进行兑换，否则蛮啾将视为您无条件放弃</span></b><b><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>用以</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>进行兑换的服务。</span></b><b><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>若您有上述行为</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>，蛮啾有权中止或终止向您提供服务内容</span></b><b><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>且</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>无需承担任何赔偿责任。</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>5.9 </span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>当您账号涉嫌盗号、外挂等非法和违规行为时，您应配合蛮啾的工作，据实回答游戏管理人员提出的与使用蛮啾产品相关的问题，以维护自己和其他您在游戏中的合法权益。<b>您同意以产品程序中的监测数据作为判断您账号是否盗号、是否有通过使用外挂程序等方法进行的游戏作弊行为以及其他违规行为的依据。</b></span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>5.10 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>您同意蛮啾出于保密义务，蛮啾仅有义务向基于法定程序要求</span></b><b><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>我方提供</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>您涉嫌盗号、使用外挂和其他蛮啾认为违规的证据</span></b><b><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>的司法机关或行政机关提供前述证据。</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>蛮啾无义务向您出示前述证据。</span></b></p>

<p style='margin-bottom:17.6pt;text-align:justify;text-justify:inter-ideograph;
text-indent:21.0pt;layout-grid-mode:char'><b><span lang=EN-US style='font-size:
10.5pt;font-family:"Times New Roman",serif;color:black;background:white'>5.11 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>蛮啾可以根据您的申请提供被盗物品找回服务，但基于游戏的特性，<u>蛮啾不对找回结果做任何明示或默示的承诺</u>，您需按照蛮啾的要求阅读找回须知、提交相关材料并自行承担相关后果。</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;layout-grid-mode:
char'><b><span lang=EN-US style='font-size:11.0pt;font-family:"Times New Roman",serif;
color:black;background:white'>6. </span></b><b><span style='font-size:11.0pt;
font-family:宋体;color:black;background:white'>服务的限制、中止或终止</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>6.1 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>您有如下任何一种或多种行为的，蛮啾有权删除您的账号或终止或中止对您的全部或部分服务（包括但不限于封停该您名下全部或部分账号和禁止有关角色登录），并且有权取消或收回您在游戏内通过违规行为获取的不当利益：</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>6.1.1 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>滥用所享有的权利；</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>6.1.2 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>提供虚假注册信息（包括但不限于身份信息和联系方式）；</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>6.1.3 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>蛮啾依据其判断，认为您账号存在高危被盗风险；</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>6.1.4 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>有损</span></b><b><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>害</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>蛮啾及相关权利人、关联公司</span></b><b><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>、</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>合作方</span></b><b><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>或</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>其他</span></b><b><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>权利人</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>合法权益的行为；</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>6.1.5 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>有违反本协议或蛮啾发布的其他服务规则的行为或通过不正当手段使用蛮啾服务的；</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>6.1.6 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>除上述情况外，您在接受蛮啾服务时实施了其他不正当行为的。</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>6.2 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>您同意，若蛮啾监测发现或经第三方举报而发现您可能正在违反本协议约定内容的，蛮啾有权依照违规严重性采取必要的处理措施，包括但不限于：屏蔽或删除您上传的信息，扣除游戏道具、游戏币或用户账号内的其他资源，重置账号昵称或头像，限制您的账号登录或限制您的游戏内活动，暂时或永久封停账号等相关措施。</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>6.3 </span><span lang=ZH
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>以</span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>同一</span><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>身份信息</span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>注册的账号中有一个账号或多个账号出现违反本协议约定的行为，蛮啾有权根据实际情况</span><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>取消前述账号或</span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>中止、终止对</span><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>前述</span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>账号的服务。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>6.4 </span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>如您希望终止本协议，可以通过申请账号注销以实现该需求。在符合本协议约定条件及国家相关法律法规规定的情况下，您可以通过</span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'><a
href="/zh/protocol/privacy" target="_blank"><span lang=EN-US
style='font-family:宋体'><span lang=EN-US>隐私政策</span></span></a></span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>提供的方式联系我们提出注销申请。除法律法规另有规定或监管部门另有要求外，账号下的内容、信息、数据、记录将会被删除或匿名化处理。用户账号注销完成后，将无法恢复。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>6.5</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>蛮啾可根据实际情况终止服务，并依照相关法律予以公告，不管由于任何原因终止服务的，您应采取相应的措施自行处理账号下的权益，包括但不限于注销或停止使用用户账号、游戏道具等。</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>6.6 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>除法律另有强制规定外，您不得因蛮啾全面终止服务而要求蛮啾承担任何形式的赔偿或补偿责任，包括但不限于因不再能继续使用用户账号、游戏道具等而要求的赔偿。</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>6.7 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>您理解并同意，蛮啾提供的产品和服务中任何标注为“永久性”“长期性”等其他同等含义的描述性词汇限定的游戏币、游戏道具或服务，其使用期限不得被解释为永远不会停止，而应被理解为其使用期限截止蛮啾宣布终止网络服务之日或因技术故障而导致游戏数据丢失之日。</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>6.8 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>您应避免因使用蛮啾提供的游戏服务而使蛮啾卷入政治和公共事件，否则蛮啾有权暂停或终止对您的服务。</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;background:white'>&nbsp;</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;layout-grid-mode:
char'><b><span lang=EN-US style='font-size:11.0pt;font-family:"Times New Roman",serif;
color:black;background:white'>7. </span></b><b><span style='font-size:11.0pt;
font-family:宋体;color:black;background:white'>服务的中断</span></b><b><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'>&nbsp;</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span style='font-size:10.5pt;font-family:宋体;
color:black;background:white'>发生下列情形之一时，即使未经通知，蛮啾有权中断所提供的服务，并不需要向您承担任何责任：</span></b><b><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'>&nbsp;</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>7.1 </span></b><b><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>我们将</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>定期对有关的网站服务器或游戏服务器及其他网络设备或所提供的产品和网络服务的相关官方网站进行必要的维护、保养及施工；</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>7.2 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>因蛮啾、蛮啾的合作方或电信网络系统软硬件设备的故障、失灵或人为操作的疏失；</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>7.3 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>他人侵入蛮啾的网络，篡改、删改或伪造、编造网站数据，或实施了任何影响蛮啾计算机系统正常运行的行为；</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>7.4 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>不可抗力原因；</span></b></p>

<p style='margin-bottom:17.6pt;text-align:justify;text-justify:inter-ideograph;
text-indent:21.0pt;layout-grid-mode:char'><b><span lang=EN-US style='font-size:
10.5pt;font-family:"Times New Roman",serif;color:black;background:white'>7.5</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>基于政府部门要求、法律或国家政策规定的其他原因。</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;layout-grid-mode:
char'><b><span lang=EN-US style='font-size:11.0pt;font-family:"Times New Roman",serif;
color:black;background:white'>8. </span></b><b><span style='font-size:11.0pt;
font-family:宋体;color:black;background:white'>测试服与体验服</span></b><b><span
lang=EN-US style='font-size:11.0pt;font-family:"Times New Roman",serif;
color:black;background:white'>&nbsp;</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span style='font-size:10.5pt;font-family:宋体;color:black;
background:white'>测试服以及体验服内的一切资料不在服务保管的范围内。您一旦登录测试服或体验服，使用测试服或体验服的游戏服务，即表示您自愿接受以下条款：</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>8.1 </span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>测试服或体验服提供的服务内容为非正式版本，可能会有与正式服务不同</span><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>的</span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>内容，可能存在程序不稳定或数据丢失的情况。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>8.2 </span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>蛮啾将不定期地对测试服或体验服进行维护，并根据需要对测试服和体验服的数据进行全部或部分的删除（包括但不限于您账号内的角色、经验值、道具及任何相关的记录和信息），或进行合法使用而无需向您承担任何责任。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>8.3 </span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>考虑到测试服和体验服的不稳定情况，蛮啾有权不对登录测试服和体验服的您提供游戏官方网站上公布的各项客户服务。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;background:white'>&nbsp;</span></p>

<p style='text-align:justify;text-justify:inter-ideograph'><b><span lang=EN-US
style='font-size:11.0pt;font-family:"Times New Roman",serif;color:black;
background:white'>9. </span></b><b><span style='font-size:11.0pt;font-family:
宋体;color:black;background:white'>个人信息保护</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;layout-grid-mode:
char'><span style='font-size:10.5pt;font-family:宋体;color:black;background:white'>　　</span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'>9.1 </span><span style='font-size:10.5pt;
font-family:宋体;color:black;background:white'>保护您的个人信息是蛮啾的一项基本政策。<b>蛮啾重视对您的个人信息的保护，一直并将继续努力采取各种合理的物理、电子和管理方面的安全措施来保护您</b></span><b><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>的</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>信息。隐私管理规则以蛮啾公布的</span></b><b><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'><a
href="/zh/protocol/privacy" target="_blank"><span lang=EN-US
style='font-family:宋体'><span lang=EN-US>《<span lang=EN-US>隐私政策<span lang=EN-US>》</span></span></span></span></a></span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>为准，请您详细阅读该条款的内容。</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;layout-grid-mode:
char'><span style='font-size:10.5pt;font-family:宋体;color:black;background:white'>　　</span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'>9.2 </span><span style='font-size:10.5pt;
font-family:宋体;color:black;background:white'>您充分理解并同意，为了解您</span><span lang=ZH
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>的</span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>需求和提升服务质量，蛮啾有权定期或不定期向您的电子邮箱、手机号码或其他您提供的联系方式发送有关的信息；蛮啾有权收集您主动提供的或者因为使用服务产生的数据，在不泄露您隐私信息的前提下，蛮啾有权</span><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>自行</span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>或通过第三方对您</span><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>的</span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>数据进行整理、统计、分析和商业化使用。蛮啾及蛮啾合作的第三方具体使用的个人信息内容及使用方式可查看</span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'><a
href="/zh/protocol/privacy" target="_blank"><span lang=EN-US
style='font-family:宋体'><span lang=EN-US>《<span lang=EN-US>隐私政策<span lang=EN-US>》</span></span></span></span></a></span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph'><b><span lang=EN-US
style='font-size:11.0pt;font-family:"Times New Roman",serif;color:black;
background:white'>10. </span></b><b><span style='font-size:11.0pt;font-family:
宋体;color:black;background:white'>未成年人使用条款</span></b><b><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black;
background:white'>&nbsp;</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>10.1</span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>蛮啾将按照相关法律法规和本协议的规定，采取切实有效的措施保护未成年人在使用蛮啾产品和服务过程中的合法权益，包括可能采取实名认证、适龄提示、采取技术措施管控、禁止未成年人接触不适宜的游戏或者游戏功能、限制未成年人的游戏时间，限制消费金额等措施，预防未成年人沉迷网络。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>10.2</span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>您在使用蛮啾产品和服务的过程中<b>不得发布、产生任何有损未成年人身心健康的内容</b>，共同营造健康网络环境。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>10.3</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>未成年人父母或其他监护人对未成年人使用电脑、智能终端设备等行为，以及通过网络游戏充值消费等行为也负有管理、监督的法定义务，应当避免未成年人沉迷游戏，严格控制相关银行或支付账号使用权限，避免未成年人利用成年人账号持续、大额的消费，从而导致不必要的损失。</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>10.4</span></b><b><u><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>成年人用户或监护人以未成年人实际使用消费为理由申请退费时，应当提供充分的证据加以证实，否则我们无法实施相应的退费。我们根据法律法规的规定实施退费时，为避免双方纠纷，您同意根据蛮啾的要求履行必要的身份验证和沟通协助，并签署相关承诺书。</span></u></b></p>

<p style='margin-top:17.6pt;text-align:justify;text-justify:inter-ideograph;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:11.0pt;font-family:
"Times New Roman",serif;color:black;background:white'>11.</span></b><b><span
style='font-size:11.0pt;font-family:宋体;color:black;background:white'>法律责任</span></b><b><span
lang=EN-US style='font-size:11.0pt;font-family:"Times New Roman",serif;
color:black;background:white'>&nbsp;</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>11.1</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>您在使用蛮啾提供</span></b><b><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>的</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>游戏服务过程中应当遵守当地相关的法律法规，并尊重当地的公共秩序与善良风俗</span></b><b><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'>.</span></b><b><span style='font-size:10.5pt;
font-family:宋体;color:black;background:white'>如果您的行为违反了当地的法律法规、公共秩序或者善良风俗，您应当为此独立承担责任。</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>11.2</span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>您同意保障和维护蛮啾及其他</span><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>人</span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>的利益，<b><u>若因您违反有关法律法规或本协议项下的任何条款而给蛮啾、蛮啾其他用户或其他第三方造成损害或损失的，您同意承担由此造成的法律责任（包括但不限于民事责任、行政责任、刑事责任等）并赔偿全部损失，前述损失包括蛮啾所受到的直接经济损失、名誉或商誉损失以及蛮啾对外支付的赔偿金、和解费用、律师费用、诉讼费用及其他间接损失。</u></b></span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'>&nbsp;</span></p>

<p style='margin-top:17.6pt;text-align:justify;text-justify:inter-ideograph;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:11.0pt;font-family:
"Times New Roman",serif;color:black;background:white'>12.</span></b><b><span
style='font-size:11.0pt;font-family:宋体;color:black;background:white'>免责声明</span></b><b><span
lang=EN-US style='font-size:11.0pt;font-family:"Times New Roman",serif;
color:black;background:white'>&nbsp;</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>12.1 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>蛮啾不保证通过蛮啾网站、蛮啾游戏官方网站及其他相关网络上的链接和标签所指向的第三方的商业信誉及其提供服务的真实性、有效性和合法性，您应当独立判断进行查看或点击。用户在使用游戏服务的过程中可能跳转至蛮啾合作方的网站、</span></b><b><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'>app</span></b><b><span style='font-size:10.5pt;
font-family:宋体;color:black;background:white'>或其他由第三方提供的服务内容（包括但不限于微信、支付宝、云闪付等支付渠道），该等服务内容由第三方独立提供，如因使用的第三方软件或技术引发的任何纠纷，应由该第三方负责解决，蛮啾不承担任何保证、担保、赔偿或其他相关责任。蛮啾不对第三方软件或技术提供客服支持，若您需要获取支持，请与该第三方联系。</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>12.2 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>在适用法律允许的最大范围内，蛮啾不会对您提供不论是明示的或默示的，包括但不限于适销性、适用性、可靠性、准确性、完整性、无病毒以及无错误等的任何保证和责任。</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>12.3 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>在适用法律允许的最大范围内，蛮啾并不担保蛮啾所提供的产品和服务一定能满足您的要求，也不担保提供的服务不会被中断，并且对产品和服务的及时性，安全性，出错发生，以及信息是否能准确，及时，顺利传送均不作任何担保。</span></b><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'>&nbsp;</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>12.4 </span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>在适用法律允许的最大范围内，蛮啾不就因您使用蛮啾的产品和服务引起的，或在任何方面与蛮啾的产品和服务有关的任何意外的、非直接的、特殊的或间接的损害或请求承担任何责任。</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>12.5 </span></b><b><u><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>蛮啾仅对本协议中列明的责任及范围负责，因政府行为、法律法规或国家相关主管部门新颁布、变更的法令、政策或其他不可抗力导致蛮啾不能提供相关产品和服务的，不视为蛮啾违约。</span></u></b></p>

<p style='margin-top:17.6pt;text-align:justify;text-justify:inter-ideograph;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:11.0pt;font-family:
"Times New Roman",serif;color:black;background:white'>13.</span></b><b><span
style='font-size:11.0pt;font-family:宋体;color:black;background:white'>争议解决</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>13.1</span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>本产品和服务相关规范的解释及适用，以及您因使用蛮啾产品和服务而与蛮啾之间所产生的权利义务关系，应适用中华人民共和国法律（不含涉外民事法律适用法或其他类似法规）。如果本协议的任何内容与法律相抵触，应以法律规定为准，本协议的其他部分将保持对您的法律效力。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>13.2</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>本协议的签订地为上海市徐汇区，</span></b><b><span
lang=ZH style='font-size:10.5pt;font-family:宋体;color:black;background:white'>与本协议</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>有关的一切争议，包括但不限于因本协议的签订或履行产生的争议、在本协议履行过程中产生的争议以及因本协议下产品和服务所产生的争议，双方应先友好协商，协商不成，任一方均可向上海市徐汇区人民法院提起诉讼。</span></b></p>

<p style='margin-top:17.6pt;text-align:justify;text-justify:inter-ideograph;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:11.0pt;font-family:
"Times New Roman",serif;color:black;background:white'>14.</span></b><b><span
style='font-size:11.0pt;font-family:宋体;color:black;background:white'>送达和通知</span></b><b><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black;background:white'>&nbsp;</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;layout-grid-mode:
char'><span style='font-size:10.5pt;font-family:宋体;color:black;background:white'>　　本协议项下所有的通知均可通过重要页面公告、电子邮件、手机短信、产品客户端消息推送等方式进行。该等通知于发送之日视为已送达收件人。</span></p>

<p style='margin-top:17.6pt;text-align:justify;text-justify:inter-ideograph;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:11.0pt;font-family:
"Times New Roman",serif;color:black;background:white'>15.</span></b><b><span
style='font-size:11.0pt;font-family:宋体;color:black;background:white'>其他</span></b><b><span
lang=EN-US style='font-size:11.0pt;font-family:"Times New Roman",serif;
color:black;background:white'>&nbsp;</span></b></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>15.1 </span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>蛮啾保留对本协议拥有修改、增补、删除、更新等权利。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>15.2</span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>本协议由本协议条款及蛮啾不时公布的各项服务规则组成，各项服务规则有约定，本协议条款未约定的或与其他单独的规则存在冲突和歧义的，以各项规则的特殊约定为准。蛮啾有权基于业务发展需要，对本协议进行修订或发布新的规则，您继续同意使用则视为对新规则的认可。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>15.3</span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>基于业务发展等原因，蛮啾的相关游戏可能由不同的关联企业所实际运营，或许需要将本协议项下的权利义务在关联企业间进行转让或转让给第三方，届时蛮啾将按照本协议约定的方式通知您。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>15.4</span><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>如本协议中的任何内容无论因何种原因完全或部分无效或不具有执行力，本协议的其余内容仍应有效并且对协议各方有约束力。</span></p>

<p style='text-align:justify;text-justify:inter-ideograph;text-indent:21.0pt;
layout-grid-mode:char'><b><span lang=EN-US style='font-size:10.5pt;font-family:
"Times New Roman",serif;color:black;background:white'>15.5</span></b><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>如您对本协议、蛮啾各项服务规则，或蛮啾提供的产品和服务存有任何疑问，可以通过蛮啾客服联系我们，客服邮箱：</span></b><span
class=MsoHyperlink><span lang=EN-US style='font-size:10.5pt'><a
href="mailto:cs@manjuu.com">cs@manjuu.com</a></span></span><b><span
style='font-size:10.5pt;font-family:宋体;color:black;background:white'>。</span></b></p>

<p class=MsoNormal><span lang=EN-US style='font-size:9.0pt;font-family:"Times New Roman",serif'>&nbsp;</span></p>

</div>

</body>

</html>

`;

export default userAgreementContent;
